import React, { useEffect, useRef } from "react";
import { cn } from "@/shared/utils/shadcn";

export function HighlightedWrapper({
  children,
  isHighlighted,
  className,
  highlightedLabel,
}: {
  children: React.ReactNode;
  isHighlighted: boolean;
  className?: string;
  highlightedLabel?: string;
}) {
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col relative break-inside-avoid" ref={wrapperRef}>
      {isHighlighted && (
        <div className="px-2 self-end mr-2 text-xs font-semibold text-blue-500 bg-blue-100 p-1 rounded-t-lg uppercase absolute top-[-22px] right-0 ">
          {highlightedLabel || "Most impactful"}
        </div>
      )}
      <div
        className={cn(
          "p-1",
          isHighlighted && "bg-blue-100 rounded-lg",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}
